import RecyclingMaterialsService from 'src/modules/recyclingMaterials/recyclingMaterialsService';
import selectors from 'src/modules/recyclingMaterials/list/recyclingMaterialsListSelectors';
import { i18n } from 'src/i18n';
import exporterFields from 'src/modules/recyclingMaterials/list/recyclingMaterialsListExporterFields';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';

const prefix = 'RECYCLINGMATERIALS_LIST';

const recyclingMaterialsListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,
  SELECTEDS_CHANGED: `${prefix}_SELECTEDS_CHANGED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  doChangeSelected(payload) {
    return {
      type: recyclingMaterialsListActions.SELECTEDS_CHANGED,
      payload,
    };
  },

  doReset: () => async (dispatch) => {
    dispatch({
      type: recyclingMaterialsListActions.RESETED,
    });

    dispatch(recyclingMaterialsListActions.doFetch());
  },

  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: recyclingMaterialsListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      const response = await RecyclingMaterialsService.list(
        filter,
        selectors.selectOrderBy(getState()),
        null,
        null,
      );

      new Exporter(
        exporterFields,
        i18n('entities.recyclingMaterials.exporterFileName'),
      ).transformAndExportAsExcelFile(response.rows);

      dispatch({
        type: recyclingMaterialsListActions.EXPORT_SUCCESS,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: recyclingMaterialsListActions.EXPORT_ERROR,
      });
    }
  },

  doChangePaginationAndSort: (pagination, sorter) => async (
    dispatch,
    getState,
  ) => {
    dispatch({
      type: recyclingMaterialsListActions.PAGINATION_CHANGED,
      payload: pagination,
    });

    dispatch({
      type: recyclingMaterialsListActions.SORTER_CHANGED,
      payload: sorter,
    });

    dispatch(recyclingMaterialsListActions.doFetchCurrentFilter());
  },

  doFetchCurrentFilter: () => async (
    dispatch,
    getState,
  ) => {
    const filter = selectors.selectFilter(getState());
    const rawFilter = selectors.selectRawFilter(getState());
    dispatch(recyclingMaterialsListActions.doFetch(filter, rawFilter, true));
  },

  doFetch: (filter?, rawFilter?, keepPagination = false) => async (
    dispatch,
    getState,
  ) => {
    try {
      dispatch({
        type: recyclingMaterialsListActions.FETCH_STARTED,
        payload: { filter, rawFilter, keepPagination },
      });

      const response = await RecyclingMaterialsService.list(
        filter,
        selectors.selectOrderBy(getState()),
        selectors.selectLimit(getState()),
        selectors.selectOffset(getState()),
      );

      dispatch({
        type: recyclingMaterialsListActions.FETCH_SUCCESS,
        payload: {
          rows: response.rows,
          count: response.count,
        },
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: recyclingMaterialsListActions.FETCH_ERROR,
      });
    }
  },
};

export default recyclingMaterialsListActions;
